bcp-add-to-cart-error-container {
  .cart-warning-message {
    color: #fcaf17;
    font-weight: 600;
    font-size: 0.85rem;
    margin-top: 5px;
    min-height: 1px;
  }
}
